import styles from "./hero.module.css";
import { useEffect, useState, useRef } from "react";
import Navigation from "../navigation/navigation";
import Icon from "./../../icons/icon";

import Video from "../../assets/video/hero.mp4";

const Hero = ({ scrollToAbout, instantScroll, data }) => {
  const [active, setActive] = useState(1);
  const [disable, setDisable] = useState(false);

  const [transitionDuration, setTransitionDuration] = useState();

  const [opacity, setOpacity] = useState(1);

  const news = data[0]?.news;

  useEffect(() => {
    const section = document.querySelector("#section1");

    const handleScroll = () => {
      let top;
      let height;
      if (window.innerWidth < 650) {
        height = -window.innerHeight * 0.6;
        top = sectionRef.current.getBoundingClientRect().top;
      } else {
        height = window.innerHeight * 0.8;
        top = section.scrollTop;
      }

      let opacity;

      opacity = (height - top) / height;

      setOpacity(opacity);
    };

    if (window.innerWidth < 650) {
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      section.addEventListener("scroll", handleScroll);

      return () => {
        section.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const sectionRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth > 850) {
      setTransitionDuration(0.25);
    } else {
      setTransitionDuration(0.5);
    }
  }, []);

  const handleNext = () => {
    if (disable) return;

    setDisable(true);

    setTimeout(() => {
      setDisable(false);
    }, 500);

    setActive((prev) => {
      if (prev + 1 === news.length) {
        return 0;
      }

      return prev + 1;
    });
  };

  const handlePrev = () => {
    if (disable) return;

    setDisable(true);

    setTimeout(() => {
      setDisable(false);
    }, 500);

    setActive((prev) => {
      if (prev === 0) {
        return news.length - 1;
      }

      return prev - 1;
    });
  };

  return (
    <div
      className={`${styles.heroWrapper}`}
      id="section1"
      style={{ opacity }}
      ref={sectionRef}
    >
      <Navigation
        scrollToAbout={scrollToAbout}
        instantScroll={instantScroll}
        data={data}
      />
      <div className={`${styles.hero}`}>
        <div className={styles.video}>
          <video muted loop autoPlay playsInline>
            <source src={Video} type="video/mp4" />
          </video>
        </div>

        <div className={styles.overlay}></div>

        <div className={`narrow-container ${styles.heroContent}`}>
          <h1>
            A new era for <br /> a invest
          </h1>

          <div className={styles.lineWrapper}>
            <div
              className={`${styles.line} ${disable ? "" : styles.animation}`}
              onAnimationIteration={() => {
                handleNext();
              }}
            ></div>
          </div>

          <div className={styles.navigationInfo}>
            <div className={styles.info}>
              <div className={styles.mobNav} onClick={handleNext}>
                <Icon type={"BlackChevron"} />
              </div>
              <div className={styles.infoTag}>
                New <span> publication</span>
              </div>
              <div className={styles.infoNews}>
                {news?.map((line, index) => (
                  <div
                    className={styles.infoLine}
                    key={index}
                    style={{
                      transform:
                        active === index
                          ? `translate(0)`
                          : active === index + 1 ||
                            (index === news.length - 1 && active === 0)
                          ? "translateY(-100%)"
                          : "translateY(100%)",

                      opacity: active === index ? 1 : 0,

                      transition:
                        active === index
                          ? `transform 0.5s linear, opacity ${transitionDuration}s linear ${transitionDuration}s`
                          : `transform 0.5s linear, opacity ${transitionDuration}s linear`,
                    }}
                  >
                    <div className={styles.date}>{line.date}</div>
                    <div className={styles.infoText}>{line.info}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.navigation}>
              <div onClick={handlePrev}>
                <Icon type={"Chevron"} />
              </div>
              <div onClick={handleNext}>
                <Icon type={"Chevron"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
